import $ from 'jquery';
import { show as showBubbleBox, elements as elementsBubbleBox } from '@ui/bubble-box';

const elements = {
  loginBarContainer: '.user-actions',
}

export const scroller = function () {
  const header = $(elements.loginBarContainer);
  const call = header.find(elementsBubbleBox.call);
  const holder = header.find(elementsBubbleBox.holder);
  const box = header.find(elementsBubbleBox.box);

  /**
   * Determine window width and scroll only when header is not fixed
   */
  const windowWidth = $(window).width();
  let promise = $.Deferred().resolve().promise();

  if (windowWidth <= 600) {
    promise = $('html, body').animate({ scrollTop: 0 }, 500).promise();
  }

  promise.done(() => {
    call.addClass('fn-active');
    showBubbleBox($(window), call, holder, box);
  });
}


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/scroller.js